import React from "react";
import { CardContent, CardDescription } from "../../components/ui/card";


const EmptyStateMessage = () => {
  return (
    <CardContent className="flex h-full flex-col items-center justify-center p-24">
      <div className="rounded-full p-24" style={{backgroundColor:"#F1F5F9"}}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-10 w-10 text-muted-foreground"
        >
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
        </svg>
      </div>
      <h3 className="mt-24 text-xl font-semibold">No selected channel</h3>
      <CardDescription className="mt-8 text-center">
        Select a channel from the sidebar to start chatting with your team.
      </CardDescription>
    </CardContent>
  );
};

export default EmptyStateMessage;
